import { mapValues } from "lodash";
import { useCustomization } from "~/Redux/Customization";
import { menuResx } from "~/resxDist/menuResx";
import { inlineEditResx } from "../../../../resxDist/inlineEditResx";
import { koPeopleTemplatesResx } from "../../../../resxDist/koPeopleTemplatesResx";

export interface ResourceGroup {
    group?: boolean;
    Name?: string;
    nonSearchable?: boolean;
}

const getGroup = (name: string): ResourceGroup => ({ group: true, Name: name });
export const resourceGroups = {
    users: getGroup(koPeopleTemplatesResx.users),
    teams: getGroup(koPeopleTemplatesResx.teams),
    jobRoles: getGroup(menuResx.jobroles),
    projectMembers: getGroup(inlineEditResx.ProjectMembers_Text),
    nonProjectMembers: getGroup(inlineEditResx.NonProjectMembers_Text),
    spaceMembers: getGroup(inlineEditResx.Space_Members),
    nonSpaceMembers: getGroup(inlineEditResx.Not_Space_Members),
} as const;

export const groupKey: { [K in keyof typeof resourceGroups]: K } = mapValues(resourceGroups, (_, key) => key) as any;
export type GroupKey = keyof typeof groupKey;

const { teams, users, jobRoles, projectMembers, nonProjectMembers, spaceMembers, nonSpaceMembers } = groupKey;

export const defaultVisibleGroups = [teams, users, jobRoles, projectMembers, nonProjectMembers];
export const defaultUsersResourceGroups = [teams, users];
const noTeamsMembers = [projectMembers, spaceMembers, nonSpaceMembers];
const assigneeMembers = [teams, ...noTeamsMembers];
const projectMembersWithSpaces = [teams, spaceMembers, nonSpaceMembers];
const noTeamsProjectMembers = [projectMembers, nonProjectMembers];

const useSpacesIsEnabled = () => {
    return useCustomization(c => c.ClientIsSpacesEnabled);
};

export const useVisibleNoTeamsMemberGroups = (): GroupKey[] => {
    const isSpacesEnabled = useSpacesIsEnabled();
    if (isSpacesEnabled) {
        return noTeamsMembers;
    }

    return noTeamsProjectMembers;
};

export const useVisibleAssigneeGroups = (): GroupKey[] => {
    const isSpacesEnabled = useSpacesIsEnabled();

    if (isSpacesEnabled) {
        return assigneeMembers;
    }
};

export const useVisibleProjectMemberGroups = (): GroupKey[] => {
    const isSpacesEnabled = useSpacesIsEnabled();
    if (isSpacesEnabled) {
        return projectMembersWithSpaces;
    }

    return defaultUsersResourceGroups;
};
